import { v4 as uuid } from 'uuid';

const CLIENT_INSTANCE_ID = 'client_instance_id';

const getInstanceId = (): string => {
    const roomAgentClientInstanceId = new URLSearchParams(global.window?.location.search || '').get(
        'room_agent_client_instance_id'
    );

    if (roomAgentClientInstanceId) {
        return roomAgentClientInstanceId;
    }

    const cachedInstanceId = global.window?.sessionStorage.getItem(CLIENT_INSTANCE_ID);

    if (cachedInstanceId) {
        return cachedInstanceId;
    }

    const instanceId = uuid();
    global.window?.sessionStorage.setItem(CLIENT_INSTANCE_ID, instanceId);

    return instanceId;
};

export const SessionState: { readonly instanceId: string } = {
    instanceId: getInstanceId(),
};
